$(() => {
  //
  const startAnimat = ($node) => {
    const targetNum = ($node.attr('data-num') * 1) || 0;
    const localNum = ($node.text() * 1) || 0;
    if (localNum < targetNum) {
      let addNum = Math.ceil(targetNum / 333);
      $node.text(String(localNum + addNum));
      setTimeout(() => {
        startAnimat($node);
      }, 10);
    } else {
      $node.text(String(targetNum));
    }
  };
  // 所有class=num-animat的元素 里面的数值跳动显示 目标值为该元素的data-num属性
  // example <span class="num-animat" data-num="123123"></span>
  $('.num-animat').each(function (index) {
    setTimeout(() => {
      startAnimat($(this));
    }, index * 100);
  });
});
